(function () {
    'use strict';
    var controllerId = 'confirmISEE';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', '$uibModalInstance', 'adesione', 'isSuper', confirmISEE]);

    function confirmISEE($scope, datacontext, $uibModalInstance, adesione, isSuper) {
        $scope.adesione = jQuery.extend({}, adesione); //Clona oggetto 
        //console.info('adesione', adesione);
        $scope.isSuper = isSuper;

        if ($scope.adesione.ISEE_iCheck == 1) {
            $scope.isValidISEE = 1;
        }
        else if ($scope.adesione.ISEE_iCheck == 3) {
            $scope.adesione.ISEE_iCheck = 1;
            $scope.isValidISEE = 2;
        }
        else if (typeof ($scope.adesione.ISEE_iCheck) == undefined || $scope.adesione.ISEE_iCheck == 0 || $scope.adesione.ISEE_iCheck == 2) {
            $scope.isValidISEE = 0;
        }

        //Impostazioni per calendario dateTimePicker
        $scope.datepickers = {};
        $scope.today = function () {
            $scope.dt = new Date();
        };
        $scope.today();

        $scope.clear = function () {
            $scope.dt = null;
        };

        // Disable weekend selection
        $scope.disabled = function (date, mode) {
            return (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
        };

        $scope.toggleMin = function () {
            $scope.minDate = $scope.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        $scope.openCalendar = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened1 = false;
            if (iOpened == 1)
                $scope.opened1 = true;
        };

        $scope.ok = function (isValid) {
            if (isValid) {

                switch ($scope.isValidISEE) {
                    case 1:
                        $scope.adesione.ISEE_iCheck = 1;
                        break;
                    case 2:
                        $scope.adesione.ISEE_iCheck = 3; //Valore ISEE differente da quello presentato
                        break;
                }

                var result = setItem($scope.adesione);
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.setCheckISEE = function (index) {
            switch (parseInt(index)) {
                case 1: //SI
                    $scope.adesione.ISEE_iCheck = 1;
                    $scope.adesione.ISEE_strConfirm = '';
                    $scope.isValidISEE = 1;
                    break;
                case 2: //NO
                    $scope.adesione.ISEE_iCheck = 2;
                    $scope.adesione.ISEE_strConfirm = '';
                    $scope.isValidISEE = 0;
                    break;
            }
        };

        function setItem(item) {
            return datacontext.CNDAdesione_setFieldsISEE(item).then(function (data) {
                return data;
            });
        }

        $scope.checkISEE = function () {
            $scope.isValidISEE = 0;
            var importo_ISEE = parseFloat($scope.adesione.strDich2_04_ISEE).toFixed(2);
            var confirm_ISEE = parseFloat($scope.adesione.ISEE_strConfirm).toFixed(2);
            //console.info('checkISEE', $scope.adesione.strDich2_04_ISEE, importo_ISEE, $scope.adesione.ISEE_strConfirm, confirm_ISEE);
            if (importo_ISEE === confirm_ISEE) {
                $scope.isValidISEE = 1; //valido
            }
            else {
                $scope.isValidISEE = 2; //Non Valido
            }
        };

    }
})();